import { isIOS } from "src/app/angular-core/utils/functions/common.functions";

export function isApp(): boolean {
  if ((<any>window).xpact) {
    return true;
  }
  else {
    return false
  }
}

export function compare<T>(a: T, b: T): number {
  if (a < b) {
    return -1;
  }
  else if (a > b) {
    return 1;
  }
  return 0;
}

export function isIOSInBrowser(): boolean {
  return isIOS() && !isApp();
}

export function downloadBlob(blob: Blob, name: string): void {
  const url = window.URL.createObjectURL(blob);
  const fileLink: HTMLAnchorElement = document.createElement('a');
  fileLink.href = url;
  fileLink.download = name;
  fileLink.click();
}

export function shortMac(mac: string): string {
  if (!mac) {
    return mac;
  }
  mac = mac.toUpperCase();
  if (mac.startsWith('84F64C') || mac.startsWith('86F64C')) {
    return mac.slice(6);
  }
  return mac;
}

export function deepCopy<T>(source: T): T {
  // This may be a bit slow, but it's the easiest way to get a proper deep copy
  return JSON.parse(JSON.stringify(source)) as T;
}